// extracted by mini-css-extract-plugin
export default {"close":"CloseModal_close__O7nk-"};